import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import PageWrapper from '../PageWrapper'
import { connect } from 'react-redux'
import { getAlljobs, promise } from '../../Action/index'
import InfiniteScroll from 'react-infinite-scroll-component';
import { Checkbox, Row } from 'antd';
import LoginFromModal from '../AlertComponent/LoginFromModal'
import Message from '../AlertComponent/Message'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ApplyJob from '../AlertComponent/ApplyJob'
import { Tooltip } from 'antd';
import DiscriptionJob from '../AlertComponent/DiscriptionJob'
import { tuple } from 'antd/lib/_util/type';
function Joblist(props) {
  const [state, setState] = useState({
    loader: false, successeres: '', loadMore: true, c_name: [], j_type: '', j_category: [], j_skill: [], j_location: [], j_experience: '0-2', j_salary: '', key_word: '', loginsuccesseres: '', selecteddetail: '', dropdown: false, filter: false,
    filterOpen: { Category: true, Skill: true, Company: true, Location: true }
  })
  const [disModal, setDisModal] = useState({ visibility: false, data: "" })
  const [login, setlogin] = useState(false)
  const [filtershow, setfiltershow] = useState(false)
  const [show, setShow] = useState(false);
  const [applyjob, setapplyjob] = useState(false)
  useEffect(() => {
    window.scrollTo({ top: 0 });
    async function loaddata() {
      if (props.location.data) {
        var old_state = await state;
        old_state.key_word = await props.location.data
        await setState(old_state)
      }
      LoadJobs(1)
    }
     loaddata();
    return () => {
    }
  }, [])
  const LoadJobs = (page_no) => {
    setState((prev) => ({ ...prev, loadMore: true, loader: true }))
    var jobList = props.joblist.data ? page_no === 1 ? [] : props.joblist.data : []
    var data = new FormData();
    var exp = state.j_experience
    var salary = state.j_salary
    data.append("action", "get_job")
    data.append("page_no", page_no)
    data.append("c_name", state.c_name)
    data.append("j_type", state.j_type)
    data.append("j_category", state.j_category)
    data.append("j_skill", state.j_skill)
    data.append("j_location", state.j_location)
    data.append("j_experience", exp)
    data.append("j_salary", salary)
    data.append("key_word", state.key_word)
    props.getAlljobs(jobList, data).then((result) => { setState((prev) => ({ ...prev, successeres: result, loader: false })); setState((prev) => ({ ...prev, loader: false })) }, err => { })
  }

  const handleChange = async (e) => {
    const { name, value } = e.target
    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const kFormatter = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'K' : Math.sign(num) * Math.abs(num)
  }
  const loadmoreData = async () => {
    props.joblist.page_no === "" ? setState((prev) => ({ ...prev, loadMore: false })) : LoadJobs(props.joblist.page_no)
  }
  const removefilter = async (data, name, item) => {
    var index = data.indexOf(item);
    data.splice(index, 1);
    await setState((prev) => ({ ...prev, [name]: data }));
    LoadJobs(1);
  }
  const addFilter = async (checkedValues, name) => {
    setfiltershow(false)
    setState((prev) => ({ ...prev, filter: false }))
    const j_category = state[name];
    if (!checkedValues.target.checked) {
      var index = j_category.indexOf(checkedValues.target.value);
      j_category.splice(index, 1);
    } else {
      j_category.push(checkedValues.target.value)
    }

    await setState((prev) => ({ ...prev, [name]: j_category }));
    LoadJobs(1);
  }
  const chnage_exp_type = async (value, name) => {

    var old_state = state;
    old_state[name] = value
    await setState(old_state);
    setState((prev) => ({ ...prev, dropdown: false }))
    // await setState((prev)=>({old_state}))
    LoadJobs(1)

  }
  const openFillter = async (name) => {
    var filterOpen = await state.filterOpen
    filterOpen[name] = !filterOpen[name]
    await setState((prev) => ({ ...prev, filterOpen: filterOpen }))
  }
  return (
    <PageWrapper title={"job"}>
      <ApplyJob show={applyjob} handleClose={() => setapplyjob(false)} detail={state.selecteddetail} handleResponce={async (data) => {
        await setapplyjob(false); await setState((prev) => ({ ...prev, loginsuccesseres: data })); setShow(true); if (data.success == "true") { setTimeout(async () => { setShow(false) }, 1000); }
      }}></ApplyJob>
      <LoginFromModal show={login} handleClose={() => setlogin(false)} handleResponce={async (data) => {
        await setlogin(false); await setState((prev) => ({ ...prev, loginsuccesseres: data })); setShow(true); if (data.success == "true") { setTimeout(async () => { setShow(false) }, 1000); }
      }}></LoginFromModal>
      <div class="inner_pages_box w-left">
        <div class="inner_pages job_list_page mb">
          <div class="container">
            <div class="mdc-title">
              <h3>Job List<span>job</span></h3>
            </div>
            <div class="job_list_filter">
              {/* {key word filter} */}
              <div class="job_list">
                <div class="job_list_inner">
                  <div class="jb_right col-12">
                    <form className="jbl_searchform">
                      <input type="text" name="key_word" placeholder="Job title, keywords, or company" onChange={handleChange} value={state.key_word} />
                      <div className="siteBtn_box" onClick={(e) => { e.preventDefault(); LoadJobs(1) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.005 512.005">
                          <path d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587zM202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z" />
                        </svg>
                        <input type="button" value="Search Jobs" onClick={(e) => { e.preventDefault() }} />
                      </div>
                    </form>
                    <div class="jobsearch-radio">

                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd1" value={1} onChange={async () => { chnage_exp_type(1, "j_type") }} checked={state.j_type === 1 ? true : false} />
                        <label for="rd1" class="radio-label">Part time</label>
                      </div>
                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd2" onChange={() => { chnage_exp_type(2, "j_type") }} checked={state.j_type === 2 ? true : false} />
                        <label for="rd2" class="radio-label">Full time</label>
                      </div>
                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd3" onChange={() => { chnage_exp_type(3, "j_type") }} checked={state.j_type === 3 ? true : false} />
                        <label for="rd3" class="radio-label">Work from home</label>
                      </div>
                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd4" onChange={() => { chnage_exp_type(4, "j_type") }} checked={state.j_type === 4 ? true : false} />
                        <label for="rd4" class="radio-label">Internship</label>
                      </div>
                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd5" onChange={() => { chnage_exp_type(5, "j_type") }} checked={state.j_type === 5 ? true : false} />
                        <label for="rd5" class="radio-label">Fresher</label>
                      </div>
                      <div class="radio">
                        <input type="radio" name="jobtype" id="rd6" onChange={() => { chnage_exp_type("", "j_type") }} checked={state.j_type === "" ? true : false} />
                        <label for="rd6" class="radio-label">Any</label>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

              {/* { Applied Filter} */}
              <div class="apply_filter">
                <span >Applied Filter:</span>
                <div class="filter_div_inner_1">
                  {state.j_category.length !== 0 &&
                    <div className="filter_div">
                      <span className="filter_name_box">catagory:</span>
                      {state.j_category.map((item) => (

                        <span class="filter_name_box">
                          <span>{item}</span>
                          <span onClick={() => removefilter(state.j_category, "j_category", item)}>
                            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" width="20" height="20">
                              <path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"></path>
                            </svg>
                          </span>
                        </span>
                      ))
                      }
                    </div>
                  }
                  {state.j_skill.length !== 0 &&
                    <div className="filter_div">
                      <span className="filter_name_box">Skill:</span>
                      {state.j_skill.map((item) => (
                        <span className="filter_name_box">
                          <span>{item}</span>
                          <span onClick={() => removefilter(state.j_skill, "j_skill", item)}>
                            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" width={20} height={20}>
                              <path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"></path>
                            </svg>
                          </span>
                        </span>
                      ))
                      }
                    </div>
                  }
                  {state.c_name.length !== 0 &&
                    <div className="filter_div">
                      <span className="filter_name_box">Company:</span>
                      {state.c_name.map((item) => (
                        <span className="filter_name_box">
                          <span>{item}</span>
                          <span onClick={() => removefilter(state.c_name, "c_name", item)}>
                            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" width={20} height={20}>
                              <path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"></path>
                            </svg>
                          </span>
                        </span>
                      ))
                      }
                    </div>
                  }
                  {state.j_location.length !== 0 &&
                    <div className="filter_div">
                      <span className="filter_name_box">Location:</span>
                      {state.j_location.map((item) => (
                        <span className="filter_name_box">
                          <span>{item}</span>
                          <span onClick={() => removefilter(state.j_location, "j_location", item)}>
                            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" width={20} height={20}>
                              <path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"></path>
                            </svg>
                          </span>
                        </span>
                      ))
                      }
                    </div>
                  }
                </div>
                <div class="filter_div_inner">
                  <span className="filter_name_box">Experience(yrs):</span>

                  <div className="dropdown" onClick={() => setState((prev) => ({ ...prev, dropdown: !state.dropdown }))}>
                    <button className={`dropdown-toggle ${state.dropdown && "active"}`} type="button" id="dropdownMenuButton">{state.j_experience}</button>
                    <div className="dropdown-menu" x-placement="bottom-start">
                      <p className={`dropdown-item ${state.j_experience === "0-2" && "active"}`} value="0 to 2 yrs" name="j_experience" onClick={() => { chnage_exp_type("0-2", "j_experience") }} >0-2</p>
                      <p className={`dropdown-item ${state.j_experience === "2-5" && "active"}`} value="2 to 5 yrs" name="j_experience" onClick={() => { chnage_exp_type("2-5", "j_experience") }} >2-5</p>
                      <p className={`dropdown-item ${state.j_experience === "5-7" && "active"}`} value="5 to 7 yrs" name="j_experience" onClick={() => { chnage_exp_type("5-7", "j_experience") }} >5-7</p>
                      <p className={`dropdown-item ${state.j_experience === "7-10" && "active"}`} value="7 to 10 yrs" name="j_experience" onClick={() => { chnage_exp_type("7-10", "j_experience") }} >7-10</p>
                      <p className={`dropdown-item ${state.j_experience === "10-15" && "active"}`} value="10 to 15 yrs" name="j_experience" onClick={() => { chnage_exp_type("10-15", "j_experience") }} >10-15</p>
                      <p className={`dropdown-item ${state.j_experience === "15-30" && "active"}`} value="15 to 30 yrs" name="j_experience" onClick={() => { chnage_exp_type("15-30", "j_experience") }} >15-30</p>
                    </div>
                  </div>

                  {((state.j_category.length !== 0) || (state.j_skill.length !== 0) || (state.c_name.length !== 0) || (state.j_location.length !== 0) || (state.j_experience !== "")) &&


                    <span class="filter_name_box clear_all" onClick={async () => {
                      // await setState((prev) => ({ ...prev, j_category: [], j_skill: [], c_name: [], j_location: [], j_experience: '', j_salary: '' }));
                      var old_state = await state;
                      old_state.j_experience = "0-2";
                      old_state.j_category = [];
                      old_state.j_skill = [];
                      old_state.c_name = [];
                      old_state.j_location = [];
                      await setState(old_state)
                      await LoadJobs(1)
                    }}>Clear All</span>
                  }
                </div>
              </div>

              <div class="job_list_filter_box mb">

                <div class="row">
                  {/* { catagory,skill,loaction,compnay} */}
                  <div class={`jbl_filter_item ${state.filter && "open"}`}>
                    <div class="filter-menu" onClick={() => setState((prev) => ({ ...prev, filter: true }))}>
                      <button>Filter</button>
                    </div>
                    <div id="accordion" class={`${state.filter && "open"}`}>
                      <div class="accordion_box">
                        <div class="close_filter" onClick={() => setState((prev) => ({ ...prev, filter: false }))}>X</div>
                        <div class="card filterCard">
                          <div class={`card-header ${!state.filterOpen.Category && "showed"}`}>
                            <span class="collapsed" data-toggle="collapse" data-target="#collapseOne" onClick={() => { openFillter("Category") }}>Category</span>
                          </div>
                          <div id="collapseOne" class="filterContent collapse show" data-parent="#accordion" style={{ display: state.filterOpen.Category ? "contents" : 'none' }} >
                            <div class="card-body">
                              <div class="filter_box">
                                <Checkbox.Group style={{ width: '100%' ,position:'relative',minHeight:172}}
                                  value={state.j_category} >
                                  {props.allfeild !== '' ? props.allfeild.category.map((option) => (
                                    <Row><Checkbox value={option.j_category}
                                      onChange={async (checkedValues) => { addFilter(checkedValues, "j_category") }}
                                    >{option.j_category}</Checkbox></Row>
                                  )):<div class="place_effect antiRow_loader"><div class="latestjob_detail"><p></p><p></p><p></p><p></p><p></p><p></p><p></p></div></div>}
                                </Checkbox.Group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card filterCard">
                          <div class={`card-header ${!state.filterOpen.Skill && "showed"}`}>
                            <span class="collapsed" data-toggle="collapse" data-target="#collapseTwo" onClick={() => { openFillter("Skill") }}>Skill</span>
                          </div>
                          <div id="collapseTwo" class="collapse" data-parent="#accordion" style={{ display: state.filterOpen.Skill ? "contents" : 'none' }} >
                            <div class="card-body">
                              <div class="filter_box">
                                <Checkbox.Group style={{ width: '100%' ,position:'relative',minHeight:172}} value={state.j_skill} >

                                  {props.allfeild !== ''? props.allfeild.skill.map((option) => (
                                    <Row><Checkbox value={option.j_skill} onChange={async (checkedValues) => { addFilter(checkedValues, "j_skill") }} >{option.j_skill}</Checkbox></Row>
                                  )):<div class="place_effect antiRow_loader"><div class="latestjob_detail"><p></p><p></p><p></p><p></p><p></p><p></p><p></p></div></div>}
                                </Checkbox.Group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card filterCard">

                          <div class={`card-header ${!state.filterOpen.Company && "showed"}`}>
                            <span class="collapsed" data-toggle="collapse" data-target="#collapseThree" onClick={() => { openFillter("Company") }}>Company</span>
                          </div>
                          <div id="collapseThree" class="collapse" data-parent="#accordion" style={{ display: state.filterOpen.Company ? "contents" : 'none' }}  >
                            <div class="card-body">
                              <div class="filter_box">
                                <Checkbox.Group style={{ width: '100%' ,position:'relative',minHeight:172}} value={state.c_name} >

                                  {props.allfeild !== '' ? props.allfeild.company_name.map((option) => (
                                    <Row><Checkbox value={option.c_name} onChange={async (checkedValues) => { addFilter(checkedValues, "c_name") }}>{option.c_name}</Checkbox></Row>
                                  )):<div class="place_effect antiRow_loader"><div class="latestjob_detail"><p></p><p></p><p></p><p></p><p></p><p></p><p></p></div></div>}
                                </Checkbox.Group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card filterCard">
                          <div class={`card-header ${!state.filterOpen.Location && "showed"}`}>
                            <span class="collapsed" data-toggle="collapse" data-target="#collapseFour" onClick={() => { openFillter("Location") }}>Location</span>
                          </div>
                          <div id="collapseFour" class="collapse" data-parent="#accordion" style={{ display: state.filterOpen.Location ? "contents" : 'none' }} >
                            <div class="card-body">
                              <div class="filter_box">
                                <Checkbox.Group style={{ width: '100%' ,position:'relative',minHeight:172}} value={state.j_location}>

                                  {props.allfeild !== ''? props.allfeild.company_location.map((option) => (
                                    <Row><Checkbox value={option.c_location} onChange={async (checkedValues) => { addFilter(checkedValues, "j_location") }}>{option.c_location}</Checkbox></Row>
                                  )):<div class="place_effect antiRow_loader"><div class="latestjob_detail"><p></p><p></p><p></p><p></p><p></p><p></p><p></p></div></div>}
                                </Checkbox.Group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class={`filter-backdrop fade ${state.filter && "show"}`} onClick={() => setState((prev) => ({ ...prev, filter: false }))}></div>
                    </div>
                  </div>
                  {/* {job list} */}
                  <div class="jbl_filter_list w-left">
                    {(Object.keys(props.joblist).length === 0) &&
                      ["1", "2", "3", "4", "5", "6"].map(() => (
                        
                          <div className="latestjob_list_item">
                            <div className="lbl_border" style={{ minHeight: 323 }}>
                              <div className={"place_effect showed"} style={{ minHeight: 320 }}>
                                <div className="lbl_img">
                                  <div className="img_div" />
                                  <div className="jbl_comname_loca">
                                    <span className />
                                    <span className />
                                  </div>
                                  <div className="siteBtn_box" />
                                </div>
                                <div className="latestjob_detail">
                                  <h4><p /></h4>
                                  <p />
                                  <a className="view_more_detail" href="Javascript:void(0)" />
                                  <p className="catetype"><span /><span /></p>
                                  <span className="expe"><span><svg /></span>
                                    <span />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                      ))}

                    {props.joblist.success === "true" ?

                      <InfiniteScroll
                        dataLength={props.joblist.data}
                        next={async () => { loadmoreData() }}
                        hasMore={state.loadMore}>
                        {props.joblist.data.map((item, index) =>

                          item && <>
                            <div className="latestjob_list_item">
                              <div className="lbl_border">
                                <div className="lbl_img">
                                  <img src={item.c_logo} alt="company" className="companyLogo" />
                                  <div className="jbl_comname_loca">
                                    <Tooltip placement="bottom" title={"Apply Now"}>
                                      <span class="jbl_item_comp_name">{item.c_name}</span>
                                    </Tooltip>
                                    <span class="jbl_comname_location">{item.c_location}</span>
                                  </div>
                                  <div class="siteBtn_box">
                                    <Tooltip placement="bottom" title={"Apply Now"}>
                                      <span>
                                        <a onClick={async () => {
                                          if (props.loginData) {
                                            await setState((prev) => ({ ...prev, selecteddetail: item })); setapplyjob(true)
                                          } else { setlogin(true) }
                                        }}><img src={require("../../images/submit_resume.png")} alt="submit_resume" /></a>
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div className="latestjob_detail">
                                  <h4>{item.j_title}</h4>
                                  <p><span>Skills: </span> {item.j_skill}</p>
                                  <a className="view_more_detail" href="Javascript:void(0)" onClick={() => { setDisModal({ visibility: true, data: item }) }}>View More</a>
                                  <p className="catetype"><span>{item.j_category}</span><span>{item.j_type}</span></p>
                                  <span className="expe"><span><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15 6.5c-.552 0-1-.448-1-1v-1.5h-4v1.5c0 .552-.448 1-1 1s-1-.448-1-1v-1.5c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v1.5c0 .552-.448 1-1 1z" /><path d="m12.71 15.38c-.18.07-.44.12-.71.12s-.53-.05-.77-.14l-11.23-3.74v7.63c0 1.52 1.23 2.75 2.75 2.75h18.5c1.52 0 2.75-1.23 2.75-2.75v-7.63z" /><path d="m24 7.75v2.29l-11.76 3.92c-.08.03-.16.04-.24.04s-.16-.01-.24-.04l-11.76-3.92v-2.29c0-1.52 1.23-2.75 2.75-2.75h18.5c1.52 0 2.75 1.23 2.75 2.75z" /></svg>{item.j_experience} year Expe</span>
                                    <span>{kFormatter(item.j_min_sal)} to {kFormatter(item.j_max_sal)}</span>
                                  </span>
                                </div>
                                <div className={state.loader ? "place_effect showed" : "place_effect"}>
                                  <div className="lbl_img">
                                    <div className="img_div" />
                                    <div className="jbl_comname_loca">
                                      <span className />
                                      <span className />
                                    </div>
                                    <div className="siteBtn_box" />
                                  </div>
                                  <div className="latestjob_detail">
                                    <h4><p /></h4>
                                    <p />
                                    <a className="view_more_detail" href="Javascript:void(0)" />
                                    <p className="catetype"><span /><span /></p>
                                    <span className="expe"><span><svg /></span>
                                      <span />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </>
                        )
                        }
                      </InfiniteScroll> : props.joblist.success === "false" &&
                      <div class="">
                        <p class="noMatched" >Sorry, no products to matched your selection</p>
                      </div>
                    }

                  </div>
                </div>
              </div>

              {/* {modal} */}
              <DiscriptionJob show={disModal} onHide={() => setDisModal({ visibility: false, data: '' })}></DiscriptionJob>

            </div>
          </div>
        </div>
        <div class="get_job_box w-left">
          <div class="container">
            <div class="row">
              <img src={require("../../images/adsa_banner.png")} alt="adbanner" />
              <div class="get_job_box_detail">
                <h2>Get Best Match your<br />job here.</h2>
                <div class="siteBtn_box"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </PageWrapper>
  )
}

//export default Home;

const mapStateToProps = (state) => {

  return {
    joblist: state.list.joblist,
    allfeild: state.list.allfeild, loginData: state.list.login
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAlljobs: (old_data, form_data) => dispatch(getAlljobs(old_data, form_data)),
    promise: (id) => dispatch(promise(id))

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Joblist));
